import { getColor, getElementId, getTitle } from '../../../../../common/elements/utils/elementPropertyUtils';
import { parseInlineBoardLinkText } from '../../../../../common/tiptap/extensions/inlineBoardLink/inlineBoardLinkUtils';
import { buildUrl } from '../../../../../common/utils/urlUtil';
import { getColorCssValue } from '../../../../element/utils/elementColorStyleUtils';
import getClientConfig from '../../../../utils/getClientConfig';
import { BoardLinkElement, BoardLinkSearchItem } from './boardLinkTypes';
import { BoardLinkSelectItem } from './useBoardLinkManager';

const { urlBase } = getClientConfig();

export const buildBoardLinkUrl = (boardId: string, permissionId?: string): string => {
    const relativeUrl = buildUrl(`/${boardId}`, permissionId ? { p: permissionId } : undefined);

    return `${urlBase}${relativeUrl}`;
};

export const mapBoardToBoardLinkItem = (board: BoardLinkElement, permissionId?: string): BoardLinkSearchItem => {
    const boardId = getElementId(board) as string;

    return {
        boardId,
        title: getTitle(board) || '',
        color: getColorCssValue(getColor(board)) || '',
        permissionId,
        url: buildBoardLinkUrl(boardId, permissionId),
        board,
    };
};

export const getBoardLinkFromPastedText = (text: string): BoardLinkSelectItem | null => {
    const parsedBoardLink = parseInlineBoardLinkText(text, urlBase);
    if (!parsedBoardLink) return null;

    return {
        boardId: parsedBoardLink.boardId,
        title: parsedBoardLink.title,
        color: '',
        permissionId: parsedBoardLink.permissionId,
        url: parsedBoardLink.url,
    };
};
